
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Merchant() {
  const steps = [
    {
      number: "01",
      title: "提交入驻申请",
      description: "填写商家基本信息，上传相关资质证明文件",
      details: [
        "营业执照副本",
        "产品质量认证证书",
        "商标注册证书",
        "产品检测报告",
        "银行开户许可证"
      ],
      icon: "ri-file-text-line"
    },
    {
      number: "02",
      title: "资质审核",
      description: "我们的专业团队将对您的资质进行严格审核",
      details: [
        "资质文件真实性验证",
        "产品质量标准评估",
        "供应链能力审查",
        "品牌形象评估",
        "客服能力考核"
      ],
      icon: "ri-shield-check-line"
    },
    {
      number: "03",
      title: "签约合作",
      description: "审核通过后，签署正式的合作协议",
      details: [
        "合作协议签署",
        "费用结算方式确定",
        "服务标准约定",
        "违约责任明确",
        "合作期限确认"
      ],
      icon: "ri-contract-line"
    },
    {
      number: "04",
      title: "店铺上线",
      description: "完成店铺装修，商品上架，正式开始销售",
      details: [
        "店铺页面设计",
        "商品信息录入",
        "价格体系设置",
        "物流配送对接",
        "客服系统培训"
      ],
      icon: "ri-store-line"
    }
  ];

  const benefits = [
    {
      title: "流量支持",
      description: "平台为优质商家提供首页推荐、活动推广等流量扶持",
      icon: "ri-line-chart-line"
    },
    {
      title: "技术支持",
      description: "提供完善的商家后台管理系统，数据分析工具",
      icon: "ri-computer-line"
    },
    {
      title: "物流支持",
      description: "与专业物流公司合作，提供优质配送服务",
      icon: "ri-truck-line"
    },
    {
      title: "营销支持",
      description: "定期举办促销活动，帮助商家提升销量",
      icon: "ri-megaphone-line"
    },
    {
      title: "培训支持",
      description: "提供电商运营培训，帮助商家快速成长",
      icon: "ri-graduation-cap-line"
    },
    {
      title: "客服支持",
      description: "专业的客服团队为商家提供全方位服务支持",
      icon: "ri-customer-service-2-line"
    }
  ];

  const requirements = [
    {
      category: "基本要求",
      items: [
        "具有合法的营业执照和相关经营资质",
        "产品符合国家质量安全标准",
        "具备稳定的供货能力",
        "承诺提供优质的客户服务"
      ]
    },
    {
      category: "办公设备类商家",
      items: [
        "持有相关产品的质量认证证书",
        "产品通过相关质量检测",
        "具备完善的售后服务体系",
        "支持产品保修和技术支持"
      ]
    },
    {
      category: "服务标准",
      items: [
        "承诺7天无理由退换货",
        "24小时内响应客户咨询",
        "按时发货，确保配送时效",
        "积极配合平台的各项活动"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section 
          className="relative h-96 flex items-center justify-center"
          style={{
            backgroundImage: "url('https://readdy.ai/api/search-image?query=Modern%20business%20partnership%20handshake%20with%20office%20equipment%20background%2C%20professional%20business%20photography%2C%20clean%20environment%2C%20bright%20lighting%2C%20success%20concept&width=1200&height=400&seq=merchant-hero&orientation=landscape')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="relative text-center text-white max-w-4xl mx-auto px-4">
            <h1 className="text-4xl font-bold mb-4">商家入驻</h1>
            <p className="text-xl mb-8">
              加入会找我平台，与我们一起为用户提供优质的办公设备和专业服务
            </p>
            <Button size="lg" className="bg-orange-500 hover:bg-orange-600">
              立即申请入驻
            </Button>
          </div>
        </section>

        {/* Process Steps */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">入驻流程</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {steps.map((step, index) => (
                <div key={index} className="relative">
                  <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow duration-200">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-lg mr-4">
                        {step.number}
                      </div>
                      <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                        <i className={`${step.icon} text-orange-500`}></i>
                      </div>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">{step.title}</h3>
                    <p className="text-gray-600 mb-4">{step.description}</p>
                    <div className="space-y-2">
                      <h4 className="font-medium text-gray-800 text-sm">所需材料：</h4>
                      <ul className="text-sm text-gray-600 space-y-1">
                        {step.details.map((detail, detailIndex) => (
                          <li key={detailIndex} className="flex items-center">
                            <i className="ri-check-line text-orange-500 mr-2 text-xs"></i>
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  {index < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                      <i className="ri-arrow-right-line text-2xl text-orange-300"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">平台优势</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="bg-white rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow duration-200">
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${benefit.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">{benefit.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Requirements */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">入驻要求</h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {requirements.map((req, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center mr-3">
                      <span className="text-white font-bold text-sm">{index + 1}</span>
                    </div>
                    {req.category}
                  </h3>
                  <ul className="space-y-3">
                    {req.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-start">
                        <i className="ri-check-line text-orange-500 mr-3 mt-1 flex-shrink-0"></i>
                        <span className="text-gray-600">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

       
      </main>

      <Footer />
    </div>
  );
}
